import { 
  AxiosRequestConfig,
  AxiosError,
  AxiosResponse,
} from "axios";

import { 
  AXIOS_INSTANCE, 
  BASE_URL,
} from "../App";

import {
  GridFilterItem,
  GridFilterModel,
} from "@mui/x-data-grid-pro";


export interface RestAPiReceipt {
  out: any[];
  opts: any[];
  dropdowns: any;
  banks: any[];
}

export interface RestApiDefaultColumnOptions {
  [key: string]: {
    CLP_filters: GridFilterModel;
    CLP_column_order: string[];
    CLP_displayableColumns: { [key: string]: boolean };
  };
}


export async function GetDefaultColumnOptions(salesOrg: string): Promise<any> {
    const config: AxiosRequestConfig = {
      method: "GET",
      params: {
        clientId: "100",
        salesOrg: salesOrg,
      },
      url: `${BASE_URL}/api/config/clpDefaultOptions`,
    };
  
    return await AXIOS_INSTANCE(config)
      .then((v) => v)
      .catch((err) => console.error(err));
  }

export function detectFilterChanges(filters: GridFilterItem[], newFilters: GridFilterItem[]){
  if (!filters) return true;
  if (filters.length !== newFilters.filter((nf) => nf.value !== undefined).length) {
    return true;
  }
  let ret: boolean = false;
  filters.forEach((of, idx: number) => {
    let nbf = newFilters.findIndex((nf: GridFilterItem) => {
      return (
        nf.columnField === of.columnField &&
        nf.operatorValue === of.operatorValue &&
        nf.value === of.value
      );
    });
    if (nbf < 0) {
      ret = true;
    }
  });
  return ret;
};

export async function getCustomerListData(clientId:number, salesOrg:string, filterLS:GridFilterModel, retryCount?: number,plantName?:any) {
  let ret:{
    failedPullingData:boolean,
    apiData:RestAPiReceipt
  } = {
    failedPullingData:false,
    apiData:{
      out: [],
      opts: [],
      dropdowns: {},
      banks:[]
    }
  };
  if (!retryCount || retryCount < 1) retryCount = 1;
  const MAX_RETRY: number = 3;
  if (retryCount > MAX_RETRY) {
    //console.log("Max retry count reached.");
    ret.failedPullingData = true;
    return ret
  }
 // console.log(`requestCustomers: ${retryCount}`);
  retryCount += 1;

  const configCustomer: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId,
      salesOrg,
    },
    data: { filters: filterLS,plant:plantName },
    url: `${BASE_URL}/api/customers`,
  };
  try {
    let res:AxiosResponse<any> = await AXIOS_INSTANCE(configCustomer)
    if (res && res.status < 400) {
      ret.apiData = {
        out: res.data.customers.map((c: any) => {
          c.id = Math.random() * Number.MAX_SAFE_INTEGER;
          return c;
        }),
        opts: res.data.opts,
        banks: res.data.banks,
        dropdowns: res.data.dropdowns,
      }
    }
  } catch (error) {
    ret = await getCustomerListData(clientId, salesOrg, filterLS, retryCount,plantName);
  }
  return ret
}


export async function updateBookmark(client_id:number, sales_org: string, customer_num: any, module:any,is_bookmark:boolean) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId:client_id,
      salesOrg:sales_org,
    },
    data: {
      customer_num: customer_num,
      module:module,
      is_bookmark:is_bookmark,
    },
    url: `${BASE_URL}/api/customers/update/bookmark`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}